import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  CircularProgress,
  Modal,
  Tooltip,
} from "@mui/material";
import SingleSelect from "../../Components/common/SingleSelect";
import TextField from "../../Components/common/TextField";
import { Trans as Translate, useTranslation } from "react-i18next";
import Button from "../../Components/common/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import instance from "../../axios";
import { errorHandler } from "../../Helpers";
import { useDispatch } from "react-redux";
import {
  useParams,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import PublishIcon from "@mui/icons-material/Publish";
import Loader from "../../Layout/Loader";
import { notifyError, notifySuccess } from "../../Utils/CustomNotifcations";
import { Dialog, DialogContent } from "@mui/material";
import { logInUserInfo } from "../../Actions/Users";
const SubmitSelfCheckIn = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { typeAndId } = useParams();
  const [form, setForm] = useState({
    serviceId: null,
    driverAddress: "",
    currentOdometer: "",
    driverName: "",
    description: "",
  });

  const [loginForm, setLoginForm] = useState({
    userEmail: "",
    userPassword: "",
  });

  const [vehicleData, setVehicleData] = useState(null);
  const [isVehicleLoading, setIsVehiclesLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [images, setImages] = useState([]);
  const [existingService, setExistingService] = useState(null);
  const [odometerTouched, setOdometerTouched] = useState(false);
  const [error, setError] = useState("");
  const [buttonVisible, setIsButtonVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isGetServiceLoading, setgetServiceLoading] = useState(false);
  const isFromWorkOrderRoute = useRef(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [isUserLogin, setIsUserLogin] = useState(true);
  const [openLogin, setOpenLogin] = useState(true);
  const [isLoginSuccess, setIsLoginSuccess] = useState(false);

  const getVehicleData = async (newId) => {
    const loginuser=JSON.parse(localStorage.getItem("userInfoFront"))
    setIsVehiclesLoading(true);
    const url = `/api/vehicles/get?search=${newId}&all=true&userId=${loginuser?.id}`;
    try {
      const response = await instance.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const data = response?.data;
      if (Array.isArray(data) && data.length > 0) {
        setVehicleData(data[0]);
      } else {
        setVehicleData(null);
      }
      setIsUserLogin(true);
    } catch (error) {
      if (error.message === "No-Session/Session-Expired") {
        setIsUserLogin(false);
      }
      setVehicleData(null);
    } finally {
      setIsVehiclesLoading(false);
    }
  };

  const getMaintenanceServices = async (vehicle) => {
    const url = `/api/services/get?createdby=all&search=${vehicle?.vehicleLicensePlate}&valid=1`;
    try {
      const response = await instance.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const updatedServices = response.data.map((service) => ({
        ...service,
        label: service.workOrderNumber
          ? `${service.workOrderNumber} - ${getStatus(service.status, t)}`
          : `${service.name} - ${getStatus(service.status, t)}`,
      }));
      setServices(updatedServices);
    } catch (error) {
      console.error("Error fetching maintenance services:", error);
    }
  };

  const getService = async (data, fromWorkOrder = false) => {
    const url = data?.workOrderNumber
      ? `/api/deliveryservices?workordernumber=${data.workOrderNumber}`
      : `/api/deliveryservices?serviceid=${data?.id}`;
    setgetServiceLoading(true);
    try {
      const response = await instance.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      if (Boolean(fromWorkOrder)) {
        const updatedResponse = { ...response };
        const formdata = {
          ...updatedResponse,
          description: updatedResponse.attributes?.description || "",
          serviceId: {
            id: updatedResponse.id || "",
            name: updatedResponse.name || "",
            workOrderNumber: updatedResponse.workOrderNumber || "",
            vehicleLicensePlate: updatedResponse.plateNumber || "",
            serviceTime: updatedResponse?.attributes?.sdate || "",
            odometer: updatedResponse?.attributes?.sodometer || "",
            attributes: {
              v_vin: updatedResponse.vin,
            },
          },
          currentOdometer: updatedResponse.odometer,
          driverName: updatedResponse.driverName || "",
        };
        setImages(
          updatedResponse?.attributes?.files
            ? [
                {
                  url: updatedResponse.attributes.files.startsWith("data:")
                    ? updatedResponse.attributes.files
                    : `data:image/png;base64,${updatedResponse.attributes.files}`,
                },
              ]
            : [],
        );
        setForm((prevState) => ({
          ...prevState,
          ...formdata,
        }));
      } else {
        setExistingService(response);
      }
    } catch (error) {
      if (fromWorkOrder) {
        dispatch(
          notifyError("No delivery service found for this work order number."),
        );
      }
      setExistingService(null);
    } finally {
      setgetServiceLoading(false);
    }
  };
  useEffect(() => {
    if (form?.serviceId && !isFromWorkOrderRoute.current) {
      getService(form?.serviceId);
    }
  }, [form?.serviceId]);

  useEffect(() => {
    if (typeAndId) {
      if (typeAndId.startsWith("w:")) {
        isFromWorkOrderRoute.current = true;
        const workOrderId = typeAndId.split(":")[1];
        let data = {
          workOrderNumber: workOrderId,
        };
        getService(data, true);
      } else if (typeAndId.startsWith("v:")) {
        isFromWorkOrderRoute.current = false;
        const vehicleId = typeAndId.split(":")[1];
        getVehicleData(vehicleId);
      }
    }
  }, [typeAndId, isLoginSuccess]);

  useEffect(() => {
    if (vehicleData) {
      getMaintenanceServices(vehicleData);
    }
  }, [vehicleData]);

  const handleChange = (field, value) => {
    if (field === "currentOdometer") {
      setOdometerTouched(true);
      setForm((prev) => ({
        ...prev,
        [field]: value?.target?.value || value,
      }));
    } else if (field === "serviceId") {
      clearForm();
      setForm((prev) => ({
        ...prev,
        [field]: value?.target?.value || value,
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [field]: value?.target?.value || value,
      }));
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (e.target) {
      e.target.value = "";
    }
    if (!file) return;

    const maxFileSize = 2 * 1024 * 1024;

    if (images?.length >= 1) {
      dispatch(notifyError("maxOneImage"));
      return;
    }
    if (!file.type.startsWith("image/")) {
      dispatch(notifyError("onlyAcceptImage"));
      return;
    }
    if (file.size > maxFileSize) {
      dispatch(notifyError("fileSize2MB"));
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const fileData = event.target.result;
      if (String(fileData).split(":")[1]?.split("/")[0] === "image") {
        setImages([
          {
            name: file.name,
            contentType: file.type,
            url: fileData,
          },
        ]);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    let attributes = { ...(form?.attributes || {}) };
    attributes.description = form?.description || "";
    attributes.sodometer = form?.serviceId?.odometer || "";
    attributes.sdate = form?.serviceId?.serviceTime || "";
    if (images?.[0]?.url) {
      attributes.files = images[0].url;
    } else {
      delete attributes.files;
    }
    // Prefer attributes.files; do not keep legacy upload payloads
    delete attributes.uploadedImages;

    let updatedForm = {
      serviceId: form?.serviceId?.id,
      workOrderNumber: form?.serviceId?.workOrderNumber || "",
      driverName: form?.driverName || "",
      odometer: form?.currentOdometer || 0,
      plateNumber: form?.serviceId?.vehicleLicensePlate,
      vin: form?.serviceId?.attributes?.v_vin,
      attributes,
    };
    try {
      const apiResponse = await instance({
        url: `/api/deliveryservices`,
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: updatedForm,
      });
      if (!isFromWorkOrderRoute.current) {
        const vehicleId = typeAndId.split(":")[1];
        history.push(`/vehicleServices/${vehicleId}`);
      }
      dispatch(notifySuccess("Delivery service submitted successfully!"));
      clearForm();
    } catch (error) {
      errorHandler(error, dispatch);
    } finally {
      setIsLoading(false);
    }
  };

  // login form
  const handleChangeLogin = (field, value) => {
    setLoginForm((prev) => ({
      ...prev,
      [field]: value?.target?.value,
    }));
  };

  const [isSubmittingLogin, setIsSubmittingLogin] = useState(false);
  const handleSubmitLoginForm = async (e) => {
    e.preventDefault();
    const { userEmail, userPassword } = loginForm;
    setIsSubmittingLogin(true);
    try {
      const userInfoFront = await instance({
        url: `/api/session`,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: new URLSearchParams({
          email: userEmail,
          password: userPassword,
          app: `3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05`,
        }),
      });
      if (userInfoFront) {
        dispatch(logInUserInfo(userInfoFront)); // localStorage.userInfoFront
        localStorage.setItem("userInfo", JSON.stringify(userInfoFront));
      }
      setIsLoginSuccess(true);
      setIsUserLogin(true);
      setOpenLogin(false);
      dispatch(notifySuccess("User Login successfully!"));
    } catch (error) {
      setIsLoginSuccess(false);
      errorHandler(error, dispatch);
    } finally {
      setIsSubmittingLogin(false);
    }
  };
  const getStatus = (status, t) => {
    return status === "expired"
      ? t("Overdue")
      : status === "required"
        ? t("customerApprove")
        : status === "completed"
          ? t("completed")
          : status === "GarageToOp"
            ? t("WaitingForOpApproval")
            : status === "GarageToCustomer" || status === "OpToCustomer"
              ? t("WaitingForCustomerApproval")
              : status === "CustomerToOp" || status === "CustomerToGarage"
                ? t("RejectedByCustomer")
                : status === "OpToGarage"
                  ? t("RejectedByOP")
                  : t(status);
  };
  const clearForm = () => {
    setForm({
      serviceId: null,
      driverName: "",
      currentOdometer: "",
      description: "",
      attributes: {},
    });
    setExistingService(null);
    setOdometerTouched(false);
    setImages([]);
  };

  const { t } = useTranslation();

  useEffect(() => {
    const currentOdoRaw = form?.currentOdometer;
    const serviceOdo = Number(form?.serviceId?.odometer);
    const hasValidService = form?.serviceId?.id && form?.serviceId?.odometer;

    let errorMsg = "";
    let showButton = false;

    if (!hasValidService) {
      showButton = false;
      setError("");
      setIsButtonVisible(false);
      return;
    }

    if (
      currentOdoRaw === "" ||
      currentOdoRaw === null ||
      currentOdoRaw === undefined
    ) {
      errorMsg = odometerTouched ? "Current odometer is required." : "";
    } else {
      const currentOdo = Number(currentOdoRaw);
      if (isNaN(currentOdo)) {
        errorMsg = "Please enter a valid number.";
      } else if (!isNaN(serviceOdo) && currentOdo < serviceOdo) {
        errorMsg =
          "Current odometer must be greater than previous service odometer.";
      } else {
        showButton = true;
      }
    }

    setError(errorMsg);
    setIsButtonVisible(showButton);
  }, [
    form?.currentOdometer,
    form?.serviceId?.odometer,
    form?.serviceId?.id,
    odometerTouched,
  ]);

  return (
    <>
      {!isUserLogin && (
        <div>
          <LoginFormModal
            open={openLogin}
            onClose={() => setOpenLogin(false)}
            form={loginForm}
            handleSubmit={handleSubmitLoginForm}
            handleChange={handleChangeLogin}
            isLoading={isSubmittingLogin}
          />
        </div>
      )}
      <>
        {isVehicleLoading ? (
          <Loader />
        ) : (
          <Container
            maxWidth="sm"
            style={{ paddingTop: "2rem", paddingBottom: "2rem" }}
          >
            <Paper elevation={3} style={{ padding: "2rem" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 1,
                  padding: "0.5rem 0rem",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <img src="/logo.png" alt="Logo" style={{ height: 50 }} />

                <Typography
                  variant="h5"
                  sx={{
                    textAlign: "center",
                    color: "#4f81bd",
                    fontWeight: "bolder",
                    paddingRight: "0.5rem",
                  }}
                >
                  Submit Self Check In
                </Typography>
              </Box>

              <form autoComplete="off" onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                  {!isFromWorkOrderRoute.current && (
                    <Grid item xs={12}>
                      <SingleSelect
                        array={services}
                        isClearable
                        id="serviceId"
                        selectName="serviceId"
                        label={<Translate i18nKey="selectMaintenanceService" />}
                        value={
                          form.serviceId?.id
                            ? {
                                id: form.serviceId.id,
                                value: form.serviceId.id,
                                label:
                                  form.serviceId.updatedLabel ||
                                  form.serviceId.label,
                              }
                            : ""
                        }
                        handleChange={handleChange}
                        canRemove
                        canAssign
                      />
                    </Grid>
                  )}

                  {isGetServiceLoading ? (
                    <Box
                      width="100%"
                      height="100%"
                      display="flex"
                      padding="5rem"
                      justifyContent="center"
                      alignItems="center"
                      backgroundColor="white"
                      zIndex="9999"
                    >
                      <CircularProgress size={40} />
                    </Box>
                  ) : (
                    <>
                      {existingService ? (
                        <p style={{ color: "red", padding: "0.5rem 1rem" }}>
                          Already Exist Service
                        </p>
                      ) : (
                        <>
                          {form?.serviceId?.id && (
                            <Grid
                              item
                              xs={12}
                              style={{
                                color: "#6FBD43",
                                margin: isFromWorkOrderRoute.current
                                  ? "1.5rem 0.5rem"
                                  : "0rem 0.5rem",
                              }}
                            >
                              <Grid container spacing={2}>
                                {form.serviceId.name && (
                                  <Grid item xs={12} sm={6}>
                                    <strong>Name:</strong> {form.serviceId.name}
                                  </Grid>
                                )}
                                {form.serviceId.workOrderNumber && (
                                  <Grid item xs={12} sm={6}>
                                    <strong>Work Order Number:</strong>{" "}
                                    {form.serviceId.workOrderNumber}
                                  </Grid>
                                )}
                                {form.serviceId?.attributes?.g_name && (
                                  <Grid item xs={12} sm={6}>
                                    <strong>Garage Name:</strong>{" "}
                                    {form.serviceId?.attributes?.g_name}
                                  </Grid>
                                )}

                                {form.serviceId?.vehicleLicensePlate && (
                                  <Grid item xs={12} sm={6}>
                                    <strong>Plate Number:</strong>{" "}
                                    {form.serviceId?.vehicleLicensePlate}
                                  </Grid>
                                )}
                                {form.serviceId?.attributes?.v_vin && (
                                  <Grid item xs={12} sm={6}>
                                    <strong>VIN:</strong>{" "}
                                    {form.serviceId?.attributes?.v_vin}
                                  </Grid>
                                )}
                                {form.serviceId?.attributes?.g_email && (
                                  <Grid item xs={12} sm={6}>
                                    <strong>Garage Email:</strong>{" "}
                                    {form.serviceId?.attributes?.g_email}
                                  </Grid>
                                )}
                                {form.serviceId?.garageNumber && (
                                  <Grid item xs={12} sm={6}>
                                    <strong>Garage Number:</strong>{" "}
                                    {form.serviceId?.garageNumber}
                                  </Grid>
                                )}

                                {form.serviceId?.odometer && (
                                  <Grid item xs={12} sm={6}>
                                    <strong>Service Odometer:</strong>{" "}
                                    {form.serviceId?.odometer}
                                  </Grid>
                                )}

                                {form.serviceId?.serviceTime && (
                                  <Grid item xs={12} sm={6}>
                                    <strong>Service Time:</strong>{" "}
                                    {moment(form?.serviceId.serviceTime).format(
                                      "DD-MM-YYYY",
                                    )}
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>
                          )}
                          <Grid item xs={12}>
                            <TextField
                              id="currentOdometer"
                              label={
                                isFromWorkOrderRoute.current ? (
                                  <Translate i18nKey="enteredOdometer" />
                                ) : (
                                  <Translate i18nKey="currentOdometer" />
                                )
                              }
                              required
                              value={form.currentOdometer || ""}
                              onChange={(e) =>
                                handleChange("currentOdometer", e)
                              }
                              variant="outlined"
                              type="number"
                              margin="dense"
                              fullWidth
                              error={!!error}
                              disabled={isFromWorkOrderRoute.current}
                              helperText={error}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              id="driverName"
                              label={<Translate i18nKey="driverName" />}
                              required
                              value={form.driverName}
                              onChange={(e) => handleChange("driverName", e)}
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              disabled={isFromWorkOrderRoute.current}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              id="description"
                              multiline
                              rows={3}
                              label={<Translate i18nKey="sharedDescription" />}
                              type="text"
                              placeholder=""
                              value={form.description}
                              onChange={(e) => handleChange("description", e)}
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              disabled={isFromWorkOrderRoute.current}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            {!isFromWorkOrderRoute.current && (
                              <>
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleImageChange}
                                  id="fileInput"
                                  style={{ display: "none" }}
                                  disabled={images?.length >= 1}
                                />

                                <label htmlFor="fileInput">
                                  <Button
                                    variant="secondary"
                                    color=""
                                    component="span"
                                    sx={{ color: "#fff", borderColor: "#fff" }}
                                    endIcon={
                                      <PublishIcon style={{ color: "#fff" }} />
                                    }
                                    disabled={images?.length >= 1}
                                  >
                                    {t("uploadImagesDoc")}
                                  </Button>
                                </label>

                                <Typography
                                  variant="caption"
                                  display="block"
                                  mt={1}
                                >
                                  <Translate i18nKey="maxOneImage">
                                    Maximum 1 image allowed.
                                  </Translate>{" "}
                                  ({t("fileSize2MB")})
                                </Typography>
                              </>
                            )}
                            <Box display="flex" flexWrap="wrap" mt={1} gap={2}>
                              {images?.map((img, index) => (
                                <Box
                                  key={index}
                                  position="relative"
                                  width={100}
                                  height={100}
                                  sx={{
                                    borderRadius: 2,
                                    overflow: "hidden",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  {!isFromWorkOrderRoute.current && (
                                    <Tooltip
                                      title="Click to remove"
                                      arrow
                                      placement="right"
                                    >
                                      <span
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          right: 1,
                                          zIndex: 2,
                                        }}
                                      >
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            setImages((prev) =>
                                              prev.filter(
                                                (_, i) => i !== index,
                                              ),
                                            )
                                          }
                                          disabled={
                                            isFromWorkOrderRoute.current
                                          }
                                          sx={{
                                            color: "#1E72B8",
                                            backgroundColor: "#f0f8ff",
                                            "&:hover": {
                                              backgroundColor: "#1E72B8",
                                              color: "white",
                                            },
                                          }}
                                        >
                                          <CloseIcon fontSize="small" />
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                  )}
                                  <Tooltip
                                    title="Click to preview"
                                    arrow
                                    placement="bottom"
                                  >
                                    <img
                                      src={img.url}
                                      alt={`preview-${index}`}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setSelectedImage(img.url);
                                        setOpenImageModal(true);
                                      }}
                                    />
                                  </Tooltip>
                                </Box>
                              ))}
                            </Box>
                          </Grid>
                          <Modal
                            open={openImageModal}
                            onClose={() => setOpenImageModal(false)}
                          >
                            <Box
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: "background.paper",
                                boxShadow: 24,
                                p: 2,
                                borderRadius: 2,
                                maxWidth: "90%",
                                maxHeight: "90%",
                                outline: "none",
                              }}
                            >
                              <IconButton
                                onClick={() => setOpenImageModal(false)}
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  color: "#fff",
                                  backgroundColor: "#1E72B8",
                                  "&:hover": {
                                    backgroundColor: "#155a94",
                                  },
                                  zIndex: 2,
                                }}
                              >
                                <CloseIcon />
                              </IconButton>
                              <img
                                src={selectedImage}
                                alt="Full size preview"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  maxHeight: "80vh",
                                  borderRadius: 8,
                                }}
                              />
                            </Box>
                          </Modal>
                          {/* disabled={!buttonVisible || isLoading} */}
                          {!isFromWorkOrderRoute.current && (
                            <Grid item xs={12} style={{ textAlign: "right" }}>
                              <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                startIcon={
                                  isLoading && (
                                    <CircularProgress
                                      size={20}
                                      color="inherit"
                                    />
                                  )
                                }
                              >
                                {isLoading ? (
                                  <Translate i18nKey="loading">
                                    Loading...
                                  </Translate>
                                ) : (
                                  <Translate i18nKey="submit">Submit</Translate>
                                )}
                              </Button>
                            </Grid>
                          )}
                        </>
                      )}
                    </>
                  )}
                </Grid>
              </form>
            </Paper>
          </Container>
        )}
      </>
    </>
  );
};

export default SubmitSelfCheckIn;

const LoginFormModal = ({
  open,
  onClose,
  form,
  handleChange,
  handleSubmit,
  isLoading,
}) => {
  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };
  return (
    <Dialog open={open} onClose={handleDialogClose}>
      <DialogContent style={{ padding: "0rem" }}>
        <div style={{ padding: "0rem" }}>
          <Paper elevation={3} style={{ padding: "2rem" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 1,
                padding: "0.5rem 0rem",
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <img src="/logo.png" alt="Logo" style={{ height: 50 }} />
            </Box>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    id="email"
                    label={<Translate i18nKey="email" />}
                    required
                    value={form?.userEmail || ""}
                    onChange={(e) => handleChange("userEmail", e)}
                    variant="outlined"
                    type="email"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="password"
                    label={<Translate i18nKey="password" />}
                    type="password"
                    value={form?.userPassword || ""}
                    onChange={(e) => handleChange("userPassword", e)}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <Button
                    type="submit"
                    style={{ width: "25%" }}
                    className="btn-submit theme-green"
                    disabled={isLoading}
                    startIcon={
                      isLoading && (
                        <CircularProgress size={20} color="inherit" />
                      )
                    }
                  >
                    {isLoading ? (
                      <Translate i18nKey="loading">Loading...</Translate>
                    ) : (
                      <Translate i18nKey="loginLogin">Submit</Translate>
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </div>
      </DialogContent>
    </Dialog>
  );
};
